var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./scripts/message-send-manager.js"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-a38eef4a!../../node_modules/vue-loader/lib/template-loader?raw&engine=pug!./templates/message-send-manager.pug"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/MessageSendManager.vue
// module id = 1312
// module chunks = 1